import { z } from 'zod';
import { subscriptionBillingCadenceSchema } from './subscriptionBillingCadence.js';
import { subscriptionPaymentMethodSchema } from './subscriptionPaymentMethod.js';
export const subscriptionOrderPlanSchema = z.object({
    name: z.string(),
    commitmentLengthInMonths: z.number().int(),
    billingCadence: subscriptionBillingCadenceSchema,
    pricePerMonth: z.string(),
    amountPerCharge: z.string(),
    commitmentTotal: z.string(),
    commitmentTotalInclVat: z.string(),
});
export const subscriptionOrderBillingAddressSchema = z.object({
    companyName: z.string(),
    line1: z.string(),
    zip: z.string(),
    city: z.string(),
});
export const subscriptionOrderCreditsSchema = z.object({
    remainingCredits: z.number().int().min(0),
    remainingMonetaryValue: z.string(),
    pricePerCredit: z.string().nullable(),
    coverageDays: z.number().int().min(0),
});
export const subscriptionOrderSummarySchema = z.object({
    greetingName: z.string(),
    plan: subscriptionOrderPlanSchema,
    agreedStartAt: z.iso.datetime().nullable(),
    paymentMethod: subscriptionPaymentMethodSchema,
    billingAddress: subscriptionOrderBillingAddressSchema.nullable(),
    credits: subscriptionOrderCreditsSchema.nullable(),
    initialFreeDays: z.number().int().min(0),
    // Zero while a credits-covered window is open, because billing is deferred until it closes.
    dueNowAmount: z.string(),
    recurringAmount: z.string(),
    // The amounts above are net, like every amount in this domain. These carry the Swiss standard rate the checkout
    // screens show alongside them; the rate Stripe Tax applies at invoicing is the one actually charged.
    dueNowAmountInclVat: z.string(),
    recurringAmountInclVat: z.string(),
    autoProlongation: z.boolean(),
    renewsForMonths: z.number().int(),
    cancellableUntil: z.iso.datetime().nullable(),
});
